export default class ButtonEntity {
    //Pesquisar exemplo por: botao: ButtonEntity
    constructor(src) {
        if (src) {
            this.src = src;
        }
    }
    getSrc() {
        return this.src;
    }
}
